export default class EventPriceDefinitions {
    static modelName = 'EventPriceDefinitions';
    id: number
    eventId: number
    memberAgeGroupId: number
    newMemberAgeGroupIds: number[]
    memberAgeGroupName: string
    memberAgeFrom: number
    memberAgeTo: number
    memberGroupTypeId: number
    newMemberGroupTypeIds: number[]
    memberGroupTypeName: string
    eventOptionId: number
    eventOption: string
    availabilityId: number
    availabilityType: string
    priceValue: number
    description: string
    [key: string]: any
}